export const FETCH_MOVEMENTS = 'FETCH_MOVEMENTS';
export const SET_MOVEMENTS = 'SET_MOVEMENTS';
export const SET_MERCHANT_TYPE = 'SET_MERCHANT_TYPE';
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';
export const SET_REFUNDS_TRANSACTION_DATA = 'SET_REFUNDS_TRANSACTION_DATA';
export const INITIAL_PAGINATION = 'INITIAL_PAGINATION';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_CURRENT_TRANSACTION = 'SET_CURRENT_TRANSACTION';
export const SET_CURRENT_REFUND = 'SET_CURRENT_REFUND';
export const SHOW_LOADING_TRANSACTIONS = 'SHOW_LOADING_TRANSACTIONS';
export const HIDE_LOADING_TRANSACTIONS = 'HIDE_LOADING_TRANSACTIONS';
export const SHOW_LOADING_CURRENT_TRANSACTION = 'SHOW_LOADING_CURRENT_TRANSACTION';
export const HIDE_LOADING_CURRENT_TRANSACTION = 'HIDE_LOADING_CURRENT_TRANSACTION';
export const SET_FILTER = 'SET_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const SET_LAST_MOVEMENTS_ERROR = 'SET_LAST_MOVEMENTS_ERROR';
export const SET_TRANSACTIONS_ERROR = 'SET_TRANSACTIONS_ERROR';
export const DOWNLOAD_TRANSACTIONS = 'TRANSACTIONS/DOWNLOAD_TRANSACTIONS';
export const DEFAULT_FILTER = 'DEFAULT_FILTER';
export const SET_ORIGINAL_TRANSACTION_SALE_AMOUNT = 'SET_ORIGINAL_TRANSACTION_SALE_AMOUNT';
export const SET_TRANSACTION_DETAILS = 'SET_TRANSACTION_DETAILS';
export const SET_ERROR_TRANSACTION_DETAILS = 'SET_ERROR_TRANSACTION_DETAILS';
export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS';
export const SHOW_LOADING_TRANSACTION_DETAILS = 'SHOW_LOADING_TRANSACTION_DETAILS';
export const HIDE_LOADING_TRANSACTION_DETAILS = 'HIDE_LOADING_TRANSACTION_DETAILS';
export const SET_TRANSACTION_REFERENCE = 'SET_TRANSACTION_REFERENCE';
export const TRANSACTION_IN_PROGRESS = 'TRANSACTION_IN_PROGRESS';
export const SHOW_LOADING_EXPORT = 'TRANSACTIONS/SHOW_LOADING_EXPORT';
export const HIDE_LOADING_EXPORT = 'TRANSACTIONS/HIDE_LOADING_EXPORT';
